/**
 * A member who has not activated a talent profile: someone who uses the app to
 * ASK for things. Talent surfaces are opt-in for them (basic-user split, UAT
 * 2026-09-11) — no focus-area declaration, no talent dashboard.
 *
 * One predicate because the rule is needed in two places that must agree: the
 * home route (what they land on) and the layout (whether it is still waiting
 * for them to finish an onboarding). When the layout counted them as "not
 * onboarded yet", it held their What's New popover back forever (#1374).
 */
export function isPlainMember(
  user?: { role?: string; talent_profile_active?: boolean } | null,
): boolean {
  return user?.role === 'member' && !user.talent_profile_active
}
